import React from 'react';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import Input from '../../../../components/elements/form/input';
import Teaxtarea from '../../../../components/elements/form/textarea';
import SelectBox from '../../../../components/elements/form/selectBox';
import { DropdownOptionType, Option } from '../../../../_config/types';
import Datepicker from '../../../../components/elements/form/datepicker';
import  Button  from '../../../../components/elements/button';
import { AgGridReact } from 'ag-grid-react';
import Icon from '../../../../components/icons';


type FormValues = {
    assetName: string;
    drop: DropdownOptionType;
    assetType: string;
    purchaseDate: Date;
};

const CreatePurchaseRequest: React.FC = () => {
    const {control, register, handleSubmit, formState: { errors } } = useForm<FormValues>();
        
        const onSubmit: SubmitHandler<FormValues> = data => {
            console.log(data);
        };
        
        const columnDefs = [
            { headerName: 'Item Code', field: 'item-code', headerClass: 'bg-[#f0f0f0]'},
            { headerName: 'Item Name', field: 'item-name', headerClass: 'bg-[#f0f0f0]'},
            { headerName: 'Vendor Part Code', field: 'vendor-part-code', headerClass: 'bg-[#f0f0f0]'},
            { headerName: 'Required Quantity', field: 'qty', headerClass: 'bg-[#f0f0f0]'},
          ];
        
          // Define row data
          const rowData: any[] = [
            { 'item-code': 'RC 001', 'item-name': 'M8 28mm Hex Bolt', 'vendor-part-code': 'VP 001', 'ordered-qty': '50 kg'},
            { 'item-code': 'RC 001', 'item-name': 'M8 28mm Hex Bolt', 'vendor-part-code': 'VP 001', 'ordered-qty': '50 kg'},
            { 'item-code': 'RC 001', 'item-name': 'M8 28mm Hex Bolt', 'vendor-part-code': 'VP 001', 'ordered-qty': '50 kg'},
            { 'item-code': 'RC 001', 'item-name': 'M8 28mm Hex Bolt', 'vendor-part-code': 'VP 001', 'ordered-qty': '50 kg'},
            { 'item-code': 'RC 001', 'item-name': 'M8 28mm Hex Bolt', 'vendor-part-code': 'VP 001', 'ordered-qty': '50 kg'},
            { 'item-code': 'RC 001', 'item-name': 'M8 28mm Hex Bolt', 'vendor-part-code': 'VP 001', 'ordered-qty': '50 kg'},
            { 'item-code': 'RC 001', 'item-name': 'M8 28mm Hex Bolt', 'vendor-part-code': 'VP 001', 'ordered-qty': '50 kg'},
            { 'item-code': 'RC 001', 'item-name': 'M8 28mm Hex Bolt', 'vendor-part-code': 'VP 001', 'ordered-qty': '50 kg'},

          ];

    return (
         <form onSubmit={handleSubmit(onSubmit)}>
            <div className='pt-4'>
                <div className='bg-green-50 py-2 px-3'>
                    <h6 className='text-[0.813rem] font-semibold'>Purchase Request ID</h6>
                    <p className='text-[0.813rem] font-normal mt-2'>P 001</p>
                </div>
                <Controller
                            name='drop'
                            control={control}
                            render={({ field :{value,onChange} }) => (
                                <SelectBox 
                                label='Location'
                                value={value}
                                onChange={onChange}
                                required
                                placeholder='AF Farm 1'
                                options={[]}
                                className='mb-0'
                                />
                            )}
                        />
                        <Controller
                            name='drop'
                            control={control}
                            render={({ field :{value,onChange} }) => (
                                <SelectBox 
                                label='Purchase Type'
                                value={value}
                                onChange={onChange}
                                required
                                placeholder='Inventory Purchase'
                                options={[]}
                                className='mb-0'
                                />
                            )}
                        />
                        
                <div className="flex justify-between items-center">
                    <h4 className='font-semibold text-[0.938rem] py-4 uppercase'>Line items</h4> <button className='text-primary'>Add parts</button>
                </div>
              
                <div className="ag-theme-alpine h-1/2">
                    <AgGridReact
                        columnDefs={columnDefs} // Pass columnDefs
                        rowData={rowData} // Pass rowData
                        pagination={false}
                        domLayout="autoHeight"
                    />
                </div>
                <Controller
                    name='assetName'
                    control={control}
                    render={({ field :{value,onChange} }) => (
                        <Input 
                        label='Name of Requester'
                        type='text'
                        value={value}
                        onChange={onChange}
                        placeholder='John Doe'
                         />
                    )}
                />
                 <Controller
                        name='purchaseDate'
                        control={control}
                        render={({ field :{value,onChange} }) => (
                            <Datepicker 
                            label='Required by'
                            value={value}
                            onChange={onChange}
                            />
                        )}
                    />
                    <p>Associate a Work Order</p>
                <Controller
                    name='assetName'
                    control={control}
                    render={({ field :{value,onChange} }) => (
                        <Teaxtarea 
                        label='Notes to Approver'
                        value={value}
                        onChange={onChange}
                        required
                        placeholder='Notes to Approver'
                         />
                    )}
                />
                <Controller
                    name='assetName'
                    control={control}
                    render={({ field :{value,onChange} }) => (
                        <Teaxtarea 
                        label='Describe Reason for Re-order'
                        value={value}
                        onChange={onChange}
                        required
                        placeholder='Describe Reason for Re-order'
                         />
                    )}
                />
               <Controller
                    name='assetName'
                    control={control}
                    render={({ field :{value,onChange} }) => (
                        <Input 
                        label='Potential Vendors'
                        type='text'
                        value={value}
                        onChange={onChange}
                        placeholder='Vendors'
                         />
                    )}
                />
                <div className='grid grid-cols-5 gap-3'>
                    <div className='border border-primary rounded-md flex px-2 py-2 text-[0.813rem] text-primary text-center justify-center items-center relative'>
                        Adiscon
                        <Icon name='close' size={0.70} className='ms-2 text-[#F31260] p-1 rounded-full bg-[#E5BDCB] absolute -top-2 -right-2' />
                    </div>
                    <div className='border border-primary rounded-md flex px-2 py-2 text-[0.813rem] text-primary text-center justify-center items-center relative'>
                        Admerc
                        <Icon name='close' size={0.70} className='ms-2 text-[#F31260] p-1 rounded-full bg-[#E5BDCB] absolute -top-2 -right-2' />
                    </div>
                    <div className='border border-primary rounded-md flex px-2 py-2 text-[0.813rem] text-primary text-center justify-center items-center relative'>
                        Adplug
                        <Icon name='close' size={0.70} className='ms-2 text-[#F31260] p-1 rounded-full bg-[#E5BDCB] absolute -top-2 -right-2' />
                    </div>
                </div>
                <hr className='border-gray-900 my-6' />
            </div>
          <div className='flex justify-end gap-2'>
                <Button working={false}>Send for Approval</Button>
                <Button working={false}>Save</Button>
                <Button theme='secondary' working={false}>Cancel</Button>
            </div>  

            <input id="assetName" {...register('assetName', { required: true })} />
                {errors.assetName && <span>This field is required</span>}

            <div>
                <label htmlFor="assetType">Asset Type</label>
                <input id="assetType" {...register('assetType', { required: true })} />
                {errors.assetType && <span>This field is required</span>}
            </div>

            <div>
                <label htmlFor="purchaseDate">Purchase Date</label>
                <input id="purchaseDate" type="date" {...register('purchaseDate', { required: true })} />
                {errors.purchaseDate && <span>This field is required</span>}
            </div>

            <button type="submit">Create Asset</button>
        </form>
    );
};

export default CreatePurchaseRequest;